const vehicleMarkerPopup = {
  batteryLevel: ' Nível da Bateria', 
  estimatedRange: 'Intervalo estimado',
  chargingStatus: 'Status de carregamento',
  charging: 'Carregando',
  notCharging: 'Não está carregando',
  unknown: 'desconhecido',
};

export default vehicleMarkerPopup;